import { render, staticRenderFns } from "./field-value-select.component.vue?vue&type=template&id=4b205a31&scoped=true"
import script from "./field-value-select.component.vue?vue&type=script&lang=ts"
export * from "./field-value-select.component.vue?vue&type=script&lang=ts"
import style0 from "./field-value-select.component.vue?vue&type=style&index=0&id=4b205a31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b205a31",
  null
  
)

export default component.exports